import api from './axios'

export default {
  getAccount: (params, config) =>
    api.get('/user/account', { params, ...config }),
  checkPrivilege: (params, config = {}) =>
    api.get('/privilege', { params, ...config })
}
